import { useGLTF, useTexture } from '@react-three/drei';
import { useRef, useEffect } from 'react';
import * as THREE from 'three';
import modelsPos from '../coordinates/modelsPos.json';

export default function Trees() {
    const { nodes } = useGLTF('./models/map/tree.glb');
    const texture = useTexture('./textures/map/tree.jpg');
    texture.flipY = false;
    
    const meshRef = useRef();
    const instanceCount = modelsPos.trees.length;
    const instanceMatrix = useRef(new Float32Array(instanceCount * 16)).current;

    useEffect(() => {
        const dummy = new THREE.Object3D();

        modelsPos.trees.forEach((pos, i) => {
            const { x, y, z, sx, sy, sz } = pos;
            dummy.position.set(x, y, z);
            dummy.scale.set(sx, sy, sz);
            dummy.updateMatrix();
            dummy.matrix.toArray(instanceMatrix, i * 16);
        });

        meshRef.current.instanceMatrix.set(instanceMatrix);
        meshRef.current.instanceMatrix.needsUpdate = true;

    }, [instanceCount, instanceMatrix]);
    
    return (
        <instancedMesh
            ref={meshRef}
            args={[nodes.tree.geometry, null, instanceCount]}
            onClick={(event) => event.stopPropagation()}
            onPointerEnter={(event) => event.stopPropagation()}
            frustumCulled={false}
        >
            <meshBasicMaterial map={texture} />
        </instancedMesh>
    );
}
